/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AnalyticsFunnelDto } from '../../models/analytics-funnel-dto';

export interface SuperadminControllerGetAnalyticsFunnel$Params {
  from?: string;
  to?: string;
}

export function superadminControllerGetAnalyticsFunnel(http: HttpClient, rootUrl: string, params?: SuperadminControllerGetAnalyticsFunnel$Params, context?: HttpContext): Observable<StrictHttpResponse<AnalyticsFunnelDto>> {
  const rb = new RequestBuilder(rootUrl, superadminControllerGetAnalyticsFunnel.PATH, 'get');
  if (params) {
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AnalyticsFunnelDto>;
    })
  );
}

superadminControllerGetAnalyticsFunnel.PATH = '/superadmin/analytics/funnel';
